import { render, staticRenderFns } from "./GoogleSignIn.vue?vue&type=template&id=8b86615c&"
import script from "./GoogleSignIn.vue?vue&type=script&lang=js&"
export * from "./GoogleSignIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports